import { render, staticRenderFns } from "./OrdersInboundCreateContent.vue?vue&type=template&id=6f1dcffe&scoped=true"
import script from "./OrdersInboundCreateContent.vue?vue&type=script&lang=js"
export * from "./OrdersInboundCreateContent.vue?vue&type=script&lang=js"
import style0 from "./OrdersInboundCreateContent.vue?vue&type=style&index=0&id=6f1dcffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dcffe",
  null
  
)

export default component.exports